import {
  Selectable,
  SelectableEntity,
  StandardActionBuilder,
} from '@infodata-group/inf-commons';
import { v4 as uuid } from 'uuid';
import { SerializedPresetInterface } from '../../interface/serialized/serialized-preset.interface';
import { StandardMenuItem } from '../standard-menu-item';
import { PresetDto } from '../../module/cartography/types/preset.dto';

export class Preset extends SelectableEntity implements Selectable {
  public folderId = '';

  private _selectedBbxId: string[] = [];
  public get selectedBbxId(): string[] {
    return this._selectedBbxId;
  }
  public set selectedBbxId(value: string[]) {
    this._selectedBbxId = value;
    if (this._selectedBbxId.length > 0) {
      this.blackboxesDisplay = 'selection';
    }
  }
  public selectedStatusBbx: string;

  private _selectedMaterialsId: string[] = [];
  public get selectedMaterialsId(): string[] {
    return this._selectedMaterialsId;
  }
  public set selectedMaterialsId(value: string[]) {
    this._selectedMaterialsId = value;
    if (this._selectedMaterialsId.length > 0) {
      this.materialsDisplay = 'selection';
    }
  }

  private _selectedSitesId: string[] = [];
  public get selectedSitesId(): string[] {
    return this._selectedSitesId;
  }
  public set selectedSitesId(value: string[]) {
    this._selectedSitesId = value;
    if (this._selectedSitesId.length > 0) {
      this.sitesDisplay = 'selection';
    }
  }

  private _blackboxesDisplay = 'none';
  public get blackboxesDisplay(): string {
    return this._blackboxesDisplay;
  }
  public set blackboxesDisplay(value: string) {
    this._blackboxesDisplay = value;
    if (value !== 'selection') {
      this.selectedBbxId = [];
    }
  }

  private _materialsDisplay = 'none';
  public get materialsDisplay(): string {
    return this._materialsDisplay;
  }
  public set materialsDisplay(value: string) {
    this._materialsDisplay = value;
    if (value !== 'selection') {
      this.selectedMaterialsId = [];
    }
  }

  private _sitesDisplay = 'none';
  public get sitesDisplay(): string {
    return this._sitesDisplay;
  }
  public set sitesDisplay(value: string) {
    this._sitesDisplay = value;
    if (value !== 'selection') {
      this.selectedSitesId = [];
    }
  }

  public version = 2;

  public createdAt: Date;
  public updatedAt: Date;

  public isNew = true;
  public override enable = true;

  public mode: 'map' | 'table' | 'path' = 'map';

  constructor(id: string, args?: PresetDto) {
    super(id ? id : uuid(), '', 'label');
    this.createdAt = new Date();

    if (!args) {
      return;
    }
    if (args.label) {
      this.label = args.label;
    }
    if (args.folderId) {
      this.folderId = args.folderId;
    }
    if (args.bbx) {
      this.selectedBbxId = args.bbx;
    }
    if (args.bbxStatus) {
      this.selectedStatusBbx = args.bbxStatus;
    }
    if (args.mats) {
      this.selectedMaterialsId = args.mats;
    }
    if (args.sites) {
      this.selectedSitesId = args.sites;
    }
    if (args.isNew !== undefined) {
      this.isNew = args.isNew;
    }
    if (args.blackboxesDisplay) {
      this.blackboxesDisplay = args.blackboxesDisplay;
    }
    if (args.materialsDisplay !== undefined) {
      this.materialsDisplay = args.materialsDisplay;
    }
    if (args.sitesDisplay !== undefined) {
      this.sitesDisplay = args.sitesDisplay;
    }
    if (args.version) {
      this.version = args.version;
    }
  }

  public override serialize(): SerializedPresetInterface {
    return {
      id: this.id,
      label: this.label,
      groupId: this.folderId,
      selectedBbxId: this.selectedBbxId,
      selectedStatusBbx: this.selectedStatusBbx,
      selectedMaterialsId: this.selectedMaterialsId,
      selectedSitesId: this.selectedSitesId,
      createdAt: this.createdAt.getTime(),
      updatedAt: this.updatedAt ? this.updatedAt.getTime() : null,
      isNew: this.isNew,
      blackboxesDisplay: this.blackboxesDisplay,
      materialsDisplay: this.materialsDisplay,
      sitesDisplay: this.sitesDisplay,
      version: this.version,
    };
  }

  public copy(): Preset {
    const preset = new Preset('', {
      label: this.label,
      folderId: this.folderId,
      bbx: this.selectedBbxId.slice(),
      bbxStatus: this.selectedStatusBbx,
      mats: this.selectedMaterialsId.slice(),
      sites: this.selectedSitesId.slice(),
      blackboxesDisplay: this.blackboxesDisplay,
      materialsDisplay: this.materialsDisplay,
      sitesDisplay: this.sitesDisplay,
      version: this.version,
    });
    preset.createdAt = this.createdAt;
    preset.updatedAt = this.updatedAt;
    preset.isNew = this.isNew;
    return preset;
  }

  public toGenericMenuItem(): StandardMenuItem {
    const item = new StandardMenuItem(
      this.id,
      this.label,
      '',
      `cartography/map/${this.id}`,
    );
    item.patternMatcher = new RegExp(
      `^cartography/(map|preset)/${this.id}$`
    );
    item.actions = [
      new StandardActionBuilder('edit-preset', 'edit')
        .setTooltip('i18n.common.edit-preset')
        .build(),
    ];
    return item;
  }
}
